import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useState, useCallback, useEffect, useRef } from 'react';
import { RequestStatus } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase } from '@lib/plugin-redux-core';
import { GET_MANY_FILE_V2_USE_CASE, DELETE_FILE_V2_USE_CASE, FileResourceType, FileV2Status } from '../../../../file-storage';
import { getManyFileV2StatusSelector, filesSelector, nextTokenSelector } from '../../redux/file-storage/file-storage.selectors';
export var useSelectLibrary = function useSelectLibrary() {
  var dispatch = useDispatch();

  var _useState = useState([]),
      files = _useState[0],
      setFiles = _useState[1];

  var _useState2 = useState([]),
      selectedFiles = _useState2[0],
      setSelectedFiles = _useState2[1];

  var _useState3 = useState(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var _useState4 = useState(false),
      isLoadingMore = _useState4[0],
      setIsLoadingMore = _useState4[1];

  var _useState5 = useState(null),
      error = _useState5[0],
      setError = _useState5[1];

  var observerRef = useRef(null); // Get status from Redux

  var getManyFileV2Status = useSelector(getManyFileV2StatusSelector);
  var filesFromRedux = useSelector(filesSelector);
  var nextToken = useSelector(nextTokenSelector);
  var getManyFileV2UseCase = getUseCase(GET_MANY_FILE_V2_USE_CASE, dispatch);
  var hasNextPage = !!nextToken; // Monitor getManyFileV2 success and update local state

  useEffect(function () {
    if (getManyFileV2Status === RequestStatus.SUCCESS && filesFromRedux) {
      if (isLoadingMore) {
        // Append files for pagination
        setFiles(function (prev) {
          return [].concat(_toConsumableArray(prev), _toConsumableArray(filesFromRedux));
        });
        setIsLoadingMore(false);
      } else if (isLoading) {
        // Replace files for initial load
        setFiles(filesFromRedux);
        setIsLoading(false);
      }
    }
  }, [getManyFileV2Status, filesFromRedux, isLoadingMore, isLoading]);
  var loadFiles = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            try {
              setError(null);
              setIsLoading(true);
              getManyFileV2UseCase.execute({
                resourceType: FileResourceType.Document,
                status: FileV2Status.Active,
                limit: 10
              });
            } catch (err) {
              setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load files');
              setIsLoading(false);
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dispatch]);
  var loadMoreFiles = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!nextToken || isLoadingMore)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            try {
              setError(null);
              setIsLoadingMore(true);
              getManyFileV2UseCase.execute({
                resourceType: FileResourceType.Document,
                status: FileV2Status.Active,
                limit: 10,
                nextToken: nextToken
              });
            } catch (err) {
              setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load more files');
              setIsLoadingMore(false);
            }

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [nextToken, isLoadingMore, dispatch]);
  var toggleFileSelection = useCallback(function (fileId) {
    setSelectedFiles(function (prev) {
      var newSelection = prev.includes(fileId) ? prev.filter(function (id) {
        return id !== fileId;
      }) : [].concat(_toConsumableArray(prev), [fileId]);
      return newSelection;
    });
  }, []);
  var deleteFile = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fileId) {
      var deleteFileV2Input, deleteFileV2UseCase;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              deleteFileV2Input = {
                id: fileId
              };
              deleteFileV2UseCase = getUseCase(DELETE_FILE_V2_USE_CASE, dispatch);
              deleteFileV2UseCase.execute(deleteFileV2Input); // Update local state

              setFiles(function (prev) {
                return prev.filter(function (file) {
                  return file.id.toString() !== fileId;
                });
              });
              setSelectedFiles(function (prev) {
                return prev.filter(function (id) {
                  return id !== fileId;
                });
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var clearSelection = useCallback(function () {
    setSelectedFiles([]);
  }, []); // Load files on component mount and clear selection

  useEffect(function () {
    clearSelection();
    loadFiles();
  }, []);
  return {
    files: files,
    selectedFiles: selectedFiles,
    isLoading: isLoading,
    isLoadingMore: isLoadingMore,
    error: error,
    hasNextPage: hasNextPage,
    loadFiles: loadFiles,
    loadMoreFiles: loadMoreFiles,
    toggleFileSelection: toggleFileSelection,
    deleteFile: deleteFile,
    clearSelection: clearSelection,
    observerRef: observerRef
  };
};